export default "__VITE_ASSET__caa3b6a0__"